import { Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { GalleriaModule } from 'primeng/galleria';
import { Item } from './gallery.models';

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [CommonModule, GalleriaModule, NgOptimizedImage],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss'
})
export class GalleryComponent {
  images = input.required<Item[] | undefined>();
  autoPlay = input(true);
  circular = input(true);
  numVisible = input(3);
  showIndicators = input(true);
  showThumbnails = input(false);
  showIndicatorsOnItem = input(true);
  showItemNavigators = input(false);
  containerStyle = input({ 'width': '100%', 'border-radius': '0' });

  responsiveOptions = input<any[]>([
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ]);

  getSrc(item: Item): string {
    return item.itemImageSrc;
  }
}
